import gql from 'graphql-tag';

export const deleteReminderRuleMutation = gql`
  mutation deleteReminderRule($id: UUID!) {
    deleteReminderRule(id: $id)
  }
`;
